import React from "react";
import DefaultPage from "./DefaultPage";
import LandingPage from "./LandingPage";
import LobbyPage from "./LobbyPage";
import HallsPage from "./HallsPage";
import BroadcastPage from "./BroadcastPage";
import SchedulePage from "./SchedulePage";
import MembersPage from "./MembersPage";
import QuizzesPage from "./QuizzesPage";
import PrizesShopPage from "./PrizesShopPage";
import UserProfilePage from "./UserProfilePage";

export default {
    'default': DefaultPage,
    'landing': LandingPage,
    'lobby': LobbyPage,
    'halls': HallsPage,
    'broadcast': BroadcastPage,
    'schedule': SchedulePage,
    'members': MembersPage,
    'program': SchedulePage,
    'quiz': QuizzesPage,
    'shop': PrizesShopPage,
    'profile': UserProfilePage,
};
